import { useEffect } from 'react';

import { useEcomStore, useUiStore } from '@/data';
import { useUpdateQueryParams } from '@/hooks';
import { CollectionQueryParams } from '@/types';

const useDeepLinkFulfillmentMethod = ({ method }: { method: string }) => {
  const [, setStoredState] = useEcomStore();
  const [, setUIState] = useUiStore();
  const { updateQueryParams } = useUpdateQueryParams();

  useEffect(() => {
    if (!method) return;

    if (method === 'pickup') {
      setStoredState({
        delivery_details: {
          delivery: false,
          pickup: true,
        },
      });
    } else if (method === 'delivery') {
      setStoredState({
        delivery_details: {
          delivery: true,
          pickup: false,
        },
      });
      setUIState({ is_store_location_open: true });
    }

    updateQueryParams(undefined as unknown as CollectionQueryParams);
  }, [method]);
};

export { useDeepLinkFulfillmentMethod };
